import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft, ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useLanguage } from '@/contexts/LanguageContext';
import { PersonalityProfile } from '@/types/resultsTypes';
interface CinematicHeroProps {
  personalityProfile: PersonalityProfile;
  completedAt: string;
}
const CinematicHero: React.FC<CinematicHeroProps> = ({
  personalityProfile,
  completedAt
}) => {
  const navigate = useNavigate();
  const {
    isAdmin
  } = useAuth();
  const {
    t, language
  } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);
  const scrollToContent = () => {
    const element = document.getElementById('personality-story');
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="relative min-h-screen flex items-center justify-center bg-background overflow-hidden">
      {/* Main hero content */}
      <div className={`relative text-center w-full max-w-4xl mx-auto px-4 sm:px-6 transition-all duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
        <div className="space-y-8 sm:space-y-12">
          {/* Date */}
          <p className="text-sm text-muted-foreground tracking-wide uppercase">
            {new Date(completedAt).toLocaleDateString(
              language === 'pt' ? 'pt-BR' : language === 'es' ? 'es-ES' : 'en-US',
              { month: 'long', day: 'numeric', year: 'numeric' }
            )}
          </p>

          {/* Main headline */}
          <div className="space-y-4 sm:space-y-6">
            <h1 className="text-5xl sm:text-7xl md:text-8xl font-semibold text-foreground tracking-tight leading-none break-words bg-gradient-to-br from-foreground via-foreground to-foreground/70 bg-clip-text">
              {personalityProfile.type}
            </h1>
            
            {/* Subtitle */}
            <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed px-2">
              {personalityProfile.description}
            </p>
          </div>

          {/* Scroll indicator */}
          <button 
            onClick={scrollToContent}
            className="inline-block text-muted-foreground hover:text-foreground transition-colors mt-12 sm:mt-16"
          >
            <ChevronDown className="h-6 w-6" />
          </button>
        </div>
      </div>
    </div>;
};
export default CinematicHero;